import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "../../shared.module";
import { CardButtonComponent } from "../../components/ui-components/buttons/card-button/card-button.component";
import { DashboardComponentCommon, DASHBOARD_COMMON_TEMPLATE, DASHBOARD_DEBUG_TEMPLATE } from "./dashboard.component.common";
import { DertApiService } from "src/app/services/api/dert.service";
import { LoginService } from "src/app/services/login.service";

@Component({
  selector: "app-desktop-dashboard",
  template: `${DASHBOARD_COMMON_TEMPLATE}${DASHBOARD_DEBUG_TEMPLATE}`,
  styleUrls: ["./dashboard.component.scss"],
  imports: [CommonModule, TranslateModule, CardButtonComponent, SharedModule],
  standalone: true,
})
export class DesktopDashboardComponent extends DashboardComponentCommon {
  private readonly dertService = inject(DertApiService);
  private readonly loginService = inject(LoginService);

  async debugLogin(
    bnr: string | number,
    voucher: string | null = null,
    action: string = DertApiService.aliveDefaults.action,
    user: string | number = DertApiService.aliveDefaults.user,
    selectedBusinessUnit: string | number = DertApiService.aliveDefaults.selectedBusinessUnit,
    roles: string = DertApiService.aliveDefaults.roles,
    email: string = DertApiService.aliveDefaults.email,
    name: string = DertApiService.aliveDefaults.name,
    login: string = DertApiService.aliveDefaults.login
  ) {
    await this.dertService.alive(
      bnr,
      voucher,
      action,
      user,
      selectedBusinessUnit,
      roles,
      email,
      name,
      login
    );
  }

  logout() {
    this.loginService.logout();
    this.router.navigate(["dashboard"]);
  }
}
